// extracted by mini-css-extract-plugin
export default {"ConfirmActionDialog":"ConfirmActionDialog_ConfirmActionDialog__3hflc","TextDialog":"ConfirmActionDialog_TextDialog__B0WNf","buttonWrapper":"ConfirmActionDialog_buttonWrapper__mE5lA"};